import { MutationCache, QueryClient } from '@tanstack/react-query';

import { installConflictToastGuard } from './conflict-toast-guard';
import { trackServerRows } from './track-server-rows';

export const queryClient: QueryClient = new QueryClient({
  // Any successful write can change what differs from the published tour
  // (see `changesQueryKey`): re-read the ones on screen. Only active queries refetch.
  mutationCache: new MutationCache({
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['tour'],
        predicate: query => query.queryKey[2] === 'changes',
      });
    },
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

// Feeds the edit-conflict guard with what the server really holds.
trackServerRows(queryClient.getQueryCache());
installConflictToastGuard();
